/** ----------------------------------------
     Utility
 ---------------------------------------- */

import unique from '@util/unique';

/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         All Cases
     ---------------------------------------- */

    getCases: state => {
        return state.data;
    },

    /** ----------------------------------------
         Get Cases by Name
     ---------------------------------------- */

    getCasesByNames: state => cases => {
        return state.data.filter(project => cases.includes(project.client));
    },

    /** ----------------------------------------
         Case by ID
     ---------------------------------------- */

    getCaseById: state => param => {
        const id = parseFloat(param);
        const findId = obj => obj.id === id;
        return state.data.find(findId);
    },

    /** ----------------------------------------
         Get Case Featured Images
     ---------------------------------------- */

    getCaseFeaturedImages: state => {
        const projects =  state.data;

        const featured = projects.map(project => project.active && project.images.featured);
        const header = projects.map(project => project.active && project.images.case);

        return {
            featured: featured,
            header: header
        }
    },

    getCaseImages: state => param => {
        const images = [];

        const id = parseFloat(param);
        const findId = obj => obj.id === id;

        const project = state.data.find(findId);
        const blocks = project.blocks;

        images.push(project.images.case);

        blocks && blocks.forEach(block => {
            if(block.type === 'image') images.push(block.content.src);
            if(block.type === 'collage' || block.type === 'parallax') block.content.images.forEach(image => images.push(image.src));
        });

        return images;
    },

    /** ----------------------------------------
        Get Next Case
     ---------------------------------------- */

    getNextId: state => param => {
        const id = parseFloat(param);
        const current = state.data.findIndex(obj => obj.id === id);

        if(current === state.data.length - 1)
            return state.data[0].id;

        return state.data[current + 1].id;
    },

    getNextProject: state => param => {
        const id = parseFloat(param);
        const current = state.data.findIndex(obj => obj.id === id);

        if(current === state.data.length - 1)
            return state.data[0];

        return state.data[current + 1];
    },

    /** ----------------------------------------
        Get Prev Case
     ---------------------------------------- */

    getPrevProject: state => param => {
        const id = parseFloat(param);
        const current = state.data.findIndex(obj => obj.id === id);

        if(current === 0)
            return state.data[state.data.length - 1];

        return state.data[current - 1];
    },

    /** ----------------------------------------
         Case Related Disciplines
     ---------------------------------------- */

    getDisciplines: state => {
        let array = [];
        const disciplines = state.data.map(project => project.disciplines);

        disciplines.forEach(discpline => {
            array.push(...discpline);
        });

        return [...new Set(array)]
    },

    /** ----------------------------------------
        Case by Discipline
     ---------------------------------------- */

    getCaseByDisciplines: state => discpline => {
        if(discpline === 'all') return state.data;
        return state.data.filter(project => project.disciplines.includes(discpline));
    },

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters